document.addEventListener('DOMContentLoaded', function () {
  const productForm =
    document.querySelector('form[action*="/cart/add"]') ||
    document.querySelector('product-form form') ||
    document.querySelector('form[id^="AddToCartForm-"]');

  console.log('productForm:', productForm);

  if (!productForm) {
    console.log('No product form found');
    return;
  }

  function waitForGloboForm(callback) {
    const interval = setInterval(function () {
      const globoForm = document.querySelector('.gpo-form__group, .globo-form-app, .gpo-app');

      if (globoForm) {
        clearInterval(interval);
        callback();
      }
    }, 300);

    setTimeout(function () {
      clearInterval(interval);
      console.log('No Globo form found after waiting');
    }, 5000);
  }

  waitForGloboForm(function () {
    const existingTools = productForm.querySelector('.globo-draft-tools');
    if (existingTools) return;

    const wrapper = document.createElement('div');
    wrapper.className = 'globo-draft-tools';
    wrapper.style.marginTop = '16px';
    wrapper.innerHTML = `
      <div style="display:flex; gap:10px; flex-wrap:wrap;">
        <button type="button" class="btn btn--secondary globo-clear-progress">
          Clear saved selections
        </button>
      </div>
      <div class="globo-draft-message" style="margin-top:8px; font-size:0.9em;"></div>
    `;

    productForm.appendChild(wrapper);

    const msg = wrapper.querySelector('.globo-draft-message');

    const productId =
      productForm.querySelector('input[name="id"]')?.value ||
      document.querySelector('[data-product-id]')?.getAttribute('data-product-id') ||
      window.location.pathname;

    const storageKey = 'globo_options_draft_' + productId;

    let autosaveMessageTimeout;

    function showAutosavedMessage() {
      if (!msg) return;

      msg.textContent = 'Selections automatically saved';

      clearTimeout(autosaveMessageTimeout);
      autosaveMessageTimeout = setTimeout(function () {
        msg.textContent = '';
      }, 1500);
    }

    function getOptionFields() {
      return Array.from(productForm.querySelectorAll('input, select, textarea')).filter((el) => {
        if (!el.name) return false;
        if (el.name === 'id') return false;
        if (el.name === 'quantity') return false;
        if (el.type === 'submit') return false;
        if (el.type === 'hidden') return false;
        return true;
      });
    }

    function saveFormState() {
      const data = {};

      getOptionFields().forEach((field) => {
        if (field.type === 'checkbox') {
          if (!data[field.name]) data[field.name] = [];
          if (field.checked) data[field.name].push(field.value);
        } else if (field.type === 'radio') {
          if (field.checked) data[field.name] = field.value;
        } else {
          data[field.name] = field.value;
        }
      });

      localStorage.setItem(storageKey, JSON.stringify(data));
    }

    function restoreFormState() {
      let data = {};

      try {
        data = JSON.parse(localStorage.getItem(storageKey) || '{}');
      } catch (e) {
        data = {};
      }

      getOptionFields().forEach((field) => {
        if (!(field.name in data)) return;

        if (field.type === 'checkbox') {
          const vals = Array.isArray(data[field.name]) ? data[field.name] : [data[field.name]];
          field.checked = vals.includes(field.value);
        } else if (field.type === 'radio') {
          field.checked = data[field.name] === field.value;
        } else {
          field.value = data[field.name];
        }

        field.dispatchEvent(new Event('change', { bubbles: true }));
        field.dispatchEvent(new Event('input', { bubbles: true }));
      });
    }

    function bindListeners() {
      getOptionFields().forEach((field) => {
        if (field.dataset.globoDraftBound === 'true') return;

        field.addEventListener('input', function () {
          saveFormState();
          showAutosavedMessage();
        });

        field.addEventListener('change', function () {
          saveFormState();
          showAutosavedMessage();
        });

        field.dataset.globoDraftBound = 'true';
      });
    }

    bindListeners();
    restoreFormState();

    const clearButton = wrapper.querySelector('.globo-clear-progress');

    if (clearButton) {
      clearButton.addEventListener('click', function () {
        localStorage.removeItem(storageKey);

        getOptionFields().forEach((field) => {
          if (field.type === 'checkbox' || field.type === 'radio') {
            field.checked = false;
          } else {
            field.value = '';
          }

          field.dispatchEvent(new Event('change', { bubbles: true }));
          field.dispatchEvent(new Event('input', { bubbles: true }));
        });

        msg.textContent = 'Saved selections cleared.';
        setTimeout(() => msg.textContent = '', 2500);
      });
    }

    let restoreTimeout;

    const observer = new MutationObserver(function () {
      bindListeners();

      clearTimeout(restoreTimeout);
      restoreTimeout = setTimeout(function () {
        restoreFormState();
      }, 300);
    });

    observer.observe(productForm, { childList: true, subtree: true });
  });
});